module.exports = __webpack_public_path__ + "static/media/march-img.3a9de0ca.jpg";